export default __webpack_public_path__ + "static/media/vida-nocturna.c090f227.svg";